var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('hr')]),_c('b-col',{attrs:{"cols":"5","md":"4"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('b-col',[_c('hr')])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }